import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuickContactsMailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"quick_contacts_mail"}/>
}
